
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lifestyle-journal/tag/[tag]",
      function () {
        return require("private-next-pages/lifestyle-journal/tag/[tag].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lifestyle-journal/tag/[tag]"])
      });
    }
  